import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const STROKES = [
  "M-50,300 C 200,120 380,520 640,300 S 1100,120 1500,340",
  "M-50,520 C 260,640 520,260 820,480 S 1300,700 1600,460",
  "M100,-40 C 220,220 120,480 360,640",
  "M1400,-20 C 1240,240 1360,520 1120,700",
];

export function KineticBackground({ dense = false }) {
  const reduce = useReducedMotion();
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* soft ambient light */}
      <div className="absolute inset-0 mesh-top" />

      {/* curved calligraphic strokes drawing in */}
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 760" preserveAspectRatio="xMidYMid slice">
        {STROKES.map((d, i) => (
          <motion.path
            key={i}
            d={d}
            fill="none"
            stroke="url(#stroke-grad)"
            strokeWidth={1.4}
            strokeLinecap="round"
            style={{ opacity: 0.5 }}
            initial={reduce ? { pathLength: 1 } : { pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 0.5 }}
            transition={{ duration: 2.6, delay: 0.2 + i * 0.35, ease: [0.25, 1, 0.5, 1] }}
          />
        ))}
        <defs>
          <linearGradient id="stroke-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#5BC8FF" stopOpacity="0.55" />
            <stop offset="55%" stopColor="#8FB4FF" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#23B4C4" stopOpacity="0.4" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default KineticBackground;
